export default __webpack_public_path__ + "static/media/goopter-pudubot-3d-obstacle-avoidance.37bfca38.jpg";